import React, { useState } from 'react';
import { observer } from 'mobx-react';
import DefaultButton from '../../../../../../global/default-button/default-button';
import { ConfigurePassportDisplayFieldKey } from '../../configure-passport-display.config';
import { DialInInfo } from './dial-in-info';
import { AudioBridgeConfigurationVM } from './audio-bridge-configuration.viewmodel';
import './audio-bridge-configuration.scss';

interface IProps {
    vm: AudioBridgeConfigurationVM;
};

export const AudioBridgeConfigurationPresentation = observer((props: IProps) => {
    const { vm } = props;

    const { formVM, isConnectionGroup, audioBridgeValues, } = vm;

    const [showDialInInfo, setShowDialInInfo] = useState<boolean>(false);
    // eslint-disable-next-line @typescript-eslint/no-shadow
    const toggleDialInInfo = () => setShowDialInInfo(showDialInInfo => !showDialInInfo);

    // [OEP-30761] - temporary force to show the show/hide button for the AudioBrdige connection
    // const showHideButtonEnabled =
    //     isConnectionGroup ? audioBridgeValues?.showHideButtonEnabled : formVM.getValue(ConfigurePassportDisplayFieldKey.SHOW_HIDE_BUTTON_ENABLED);
    const showHideButtonEnabled = true;
    const showDialInInfoButtonLabel =
        isConnectionGroup ? audioBridgeValues?.showDialInInfo : formVM.getValue(ConfigurePassportDisplayFieldKey.SHOW_DIAL_IN_INFO);
    const hideDialInInfoButtonLabel =
        isConnectionGroup ? audioBridgeValues?.hideDialInInfo : formVM.getValue(ConfigurePassportDisplayFieldKey.HIDE_DIAL_IN_INFO);

    const displayShowDialInInfoButton = `show-dial-in-info__${showDialInInfo ? 'block' : 'hidden'}`;
    const dialInfoButtonTitle = showDialInInfo ? hideDialInInfoButtonLabel : showDialInInfoButtonLabel;

    return (
        <div className='show-dial-in-info'>
            <div className={showHideButtonEnabled ? displayShowDialInInfoButton : ''}>
                <DialInInfo vm={vm} />
            </div>
            {showHideButtonEnabled && (
                <DefaultButton
                    text={dialInfoButtonTitle}
                    modifier={['fat', 'confirm-safe']}
                    onClick={toggleDialInInfo}
                />
            )}
        </div>
    );
});
